import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import getFormattedValues, { formatReceived } from 'utils/formatValues';

export const baseURI = '/empresas/contratos-de-policias/';

/**
 * GET Contratos de Policias
 * @param {Object} params
 * @returns {Promise<Array<Object>>}
 */
export const getContratosDePolicias = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET Contrato de Policia
 * @param {number} id
 * @returns {Promise<Object>}
 */
export const getContratoDePolicia = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Contrato de Policia
  * @param {Object} values
 * @returns {Promise<Object>}
 */
export const postContratoDePolicia = async (values) => {
  try {
    const response = await API.post(baseURI, getFormattedValues(values));
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Contrato de Policia
 * @param {number} id
 * @param {Object} values
 * @returns {Promise<Object>}
 */
export const patchContratoDePolicia = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, getFormattedValues(values));
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Contrato de Policia
 * @param {number} id
 * @returns {Promise<Object>}
 */
export const deleteContratoDePolicia = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * GET Contrato de Policia para la caja
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */
export const getContratosDePoliciasCaja = async (params = null) => {
  try {
    const response = await API.get('empresas/contratos-de-policias-caja/', { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};
